export default __webpack_public_path__ + "static/media/avatar_97.dfb4e6e5.png";